import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { UserProfileDto, userProfileInit } from '../types/UserProfileDto'
import useUserProfileFetcher from '../hooks/useUserProfileFetcher'

import UserEdit from './UserEdit'

const UserEditPage: React.FC = () => {
  // Extracting id parameter from the route
  const { id } = useParams<{ id: string }>()
  const [userProfile, setUserProfile] = useState<UserProfileDto>()
  const { fetchUserProfileDetail, errorUserProfile } = useUserProfileFetcher()
  const [creating, setCreating] = useState<boolean>(false)

  useEffect(() => {
    if (!id) {
      return // Exit early if `id` is undefined
    }

    // id 0   creando
    if (id === '0') {
      setUserProfile(userProfileInit)
      setCreating(true)

      return
    }
    const fetchDataAsync = async () => {
      const data = await fetchUserProfileDetail(id)

      if (!data) return
      setUserProfile(data)
      setCreating(false)
    }

    fetchDataAsync()
  }, [id])

  return (
    <>
      {userProfile && <UserEdit userProfile={userProfile} creating={creating} />}

      <div>{errorUserProfile?.message}</div>
    </>
  )
}

export default UserEditPage
